'use client';

import 'moment/locale/ar';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePickerIcon from '../components/svg/DatePickerIcon';


const symbolMap = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '0': '0'
};
const numberMap = {
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
  '٠': '0'
}
  moment.updateLocale('ar', {
    preparse: function (string: string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match: any) {
          //@ts-ignore
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function(string: string) {
      return string.replace(/\d/g, function(match: any) {
        //@ts-ignore
        return symbolMap[match as any] as string;
      }).replace(/,/g, '،');
    },
    });

export default function PollDateRenderer({value}:{value: string | Date}){ 
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  },[]);
  if (!show) return null;

  return (
    <div className='flex items-start gap-[8px] flex-shrink-0'>
      <DatePickerIcon className='dark:[&>*]:fill-white'/>
      <span className='font-medium whitespace-nowrap'>{moment(value).format('DD MMMM YYYY')}</span>
    </div>
  )
}